// extracted by mini-css-extract-plugin
module.exports = {"container":"vertical_card_content-module_container_f54de","threePart":"vertical_card_content-module_threePart_21327","twoPart":"vertical_card_content-module_twoPart_297f1"};